export default __webpack_public_path__ + "static/media/4db07f084905c00ddccbe08ddf57da7b1582830101975.1fbefda2.webp";